import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import uploadPicture from "../../assets/images/svg/uploadPicture.svg";
import ArrowButton from "../../components/ArrowButton";
import Header from "../../components/Header/Header";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import InputForLiaison from "../../components/InputForLiaison/InputForLiaison";
import SettingFamilyCard from "../../components/SettingFamilyCard/SettingFamilyCard";
import SettingModalButton from "../../components/SettingModalButton/SettingModalButton";
import defaultImgForLiasionAccess from "../../assets/images/svg/defaultImgForLiasionAccess.svg";
import addLiaisonOfficer from "../../assets/images/svg/addLiaisonOfficer.svg";
import imageIcon from "../../assets/images/svg/imageIcon.svg";
import cameraIcon from "../../assets/images/svg/cameraIcon.svg";
import Modal from "../../components/Modal";
import SettingPermitModal from "../../components/SettingPermitModal/SettingPermitModal";
import { Observer, observer } from "mobx-react";
import { toJS } from "mobx";
import ToggleButton from "../../components/ToggleButton/ToggleButton";
import {
  checkUserEmailValidation,
  getDecodedToken,
  getFileSize,
} from "../../utils/functions";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import SettingsStore from "../../store/SettingsStore";
import ProfileStore2 from "../../store/ProfileStore2";
import PageHeading from "../../components/PageHeading/PageHeading";
import {
  addFamilyOfficeTeamRoute,
  editFamilyOfficeTeamRoute,
  familyOfficeTeamNameText,
} from "../../utils/constants";

const AddImageModalContent = ({
  uploadMessage,
  setUploadMessage,
  handleCancel,
  isUploadSuccess,
  setIsUploadSuccess,
  location,
  setUploadImgStatus,
  uploadImgStatus,
  setUploadPictureModal,
}) => {
  const fileRef = useRef();

  const uploadFile = (fileVar) => {
    const file = getSelectedFile(fileVar);
    const validation = validateFile(file);
    switch (validation) {
      case "file size error":
        setUploadMessage({
          message: "File size larger than 10 MB",
          isError: true,
        });
        if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
          SettingsStore.updateProfile(null);
        } else if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
          SettingsStore.setTempProfile(null);
        }
        break;
      case "file type error":
        setUploadMessage({
          message: "Only JPEG and PNG image formats are supported",
          isError: true,
        });
        if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
          SettingsStore.updateProfile(null);
        } else if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
          SettingsStore.setTempProfile(null);
        }
        break;
      case "valid file":
        setUploadMessage({
          message: "",
          isError: false,
        });
        if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
          SettingsStore.updateProfile(file);
        } else if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
          SettingsStore.setTempProfile(file);
        }
        break;
      default:
        break;
    }
  };

  const validateFile = (file) => {
    const allowedFileExtention = [".png", ".jpeg", ".jpg"];
    const fileExtention = file?.name.substring(file?.name.lastIndexOf("."));
    const isFileSizevalid = file?.exactSize < 10485760;
    const isFileTypeValid = allowedFileExtention.includes(
      fileExtention.toLowerCase(),
    );
    if (!isFileSizevalid) {
      return "file size error";
    }
    if (!isFileTypeValid) {
      return "file type error";
    }
    if (isFileSizevalid && isFileTypeValid) {
      return "valid file";
    }
  };

  const getSelectedFile = (file) => {
    if (file) {
      const fileSrc = URL.createObjectURL(file);
      return {
        name: file.name,
        size: getFileSize(file.size),
        exactSize: file.size,
        type: file.type,
        src: fileSrc,
        file: file,
      };
    } else {
      return null;
    }
  };

  const handleFileClick = () => {
    if (
      (location.pathname.includes(addFamilyOfficeTeamRoute) &&
        !SettingsStore.profile) ||
      (location.pathname.includes(editFamilyOfficeTeamRoute) &&
        !SettingsStore.tempProfileForUpdate)
    ) {
      fileRef.current.click();
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const dt = e.dataTransfer;
    const file = dt.files[0];
    uploadFile(file);
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const _file = e.target.files[0];
    uploadFile(_file);
  };

  const stopDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const getImageType = (type) => {
    switch (type) {
      case "image/png":
        return "PNG";
      case "image/jpeg":
        return "JPEG";
      case "image/jpg":
        return "JPG";
      default:
        return "";
    }
  };

  const handleUpload = () => {
    if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
      setUploadImgStatus("uploading");
      if (SettingsStore.profile) {
        ProfileStore2.uploadProfile2(
          SettingsStore?.profile,
          SettingsStore.liaisonOfficerData?.profile?.user_id,
          {
            onSucess: (data) => {
              SettingsStore.updateAddLiaisonOfficerUrl(data.url);
              setUploadImgStatus("success");
              setUploadPictureModal(false);
              setTimeout(() => {
                handleSave();
                setIsUploadSuccess("idle");
              }, 1000);
            },
            onFail: (error) => {
              setUploadMessage({
                message: "Error While Uploading Profile Photo",
                isError: true,
              });
              setUploadImgStatus("error");
            },
          },
        );
      }
    } else if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
      setUploadImgStatus("uploading");
      if (SettingsStore.tempProfileForUpdate) {
        ProfileStore2.uploadProfile2(
          SettingsStore.tempProfileForUpdate,
          SettingsStore.liaisonOfficerData.profile.user_id,
          {
            onSucess: (data) => {
              setUploadImgStatus("success");
              SettingsStore.updateProfilePic(data.url);
              setUploadMessage({
                message:
                  "Family office team profile picture uploaded successfully",
                isError: false,
              });
              setTimeout(() => {
                handleSave();
                setIsUploadSuccess("idle");
              }, 2000);
            },
            onFail: (error) => {
              setUploadImgStatus("error");
              setUploadMessage({
                message: "Error While Uploading Profile Photo",
                isError: true,
              });
            },
          },
        );
      }
    }
    setIsUploadSuccess(true);
  };

  const handleSave = () => {
    SettingsStore.updateProfile(SettingsStore.tempProfileForUpdate);
    SettingsStore.setTempProfile(null);
    setUploadPictureModal(false);
    setUploadMessage({
      message: "",
      isError: false,
    });
    setIsUploadSuccess(false);
  };

  const handleRemove = () => {
    if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
      SettingsStore.updateProfile(null);
    } else if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
      SettingsStore.setTempProfile(null);
    }
    setUploadMessage({
      message: "",
      isError: false,
    });
    setIsUploadSuccess(false);
  };

  const getContentForDashedArea = () => {
    if (
      (location.pathname.includes(addFamilyOfficeTeamRoute) &&
        SettingsStore.profile) ||
      (location.pathname.includes(editFamilyOfficeTeamRoute) &&
        SettingsStore.tempProfileForUpdate)
    ) {
      return (
        <div className="selected_image_container">
          <img src={imageIcon} alt="icon" />
          <p className="file_details">
            {SettingsStore.tempProfileForUpdate?.name ||
              SettingsStore.profile?.name}{" "}
            -{" "}
            {SettingsStore.tempProfileForUpdate?.size ||
              SettingsStore.profile?.size}{" "}
            {getImageType(
              SettingsStore.tempProfileForUpdate?.type ||
                SettingsStore.profile?.type,
            )}{" "}
            format
          </p>
          {uploadImgStatus !== "success" && uploadImgStatus !== "uploading" && (
            <button className="remove_btn" onClick={handleRemove}>
              Remove
            </button>
          )}
        </div>
      );
    } else {
      return (
        <div
          onDragEnter={stopDefault}
          onDragOver={stopDefault}
          onDrop={handleDrop}
          className="drap_and_drop_container_border"
        >
          <div className="drap_and_drop_container">
            <p className="drag_drop_text">Drag and drop your image </p>
            <p className="file_support_text">
              Files Supported: JPEG, PNG and Maximum Size: 10 MB
            </p>
          </div>
          <input
            onChange={handleInputChange}
            type="file"
            accept="image/png, image/jpeg"
            style={{ display: "none" }}
            ref={fileRef}
          />
        </div>
      );
    }
  };

  const checkDisabled = () => {
    if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
      return !SettingsStore.profile;
    } else if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
      return !SettingsStore.tempProfileForUpdate;
    }
  };

  const getCurrentProfile = () => {
    if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
      return SettingsStore.profile
        ? SettingsStore.profile.src
        : defaultImgForLiasionAccess;
    } else if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
      return SettingsStore.tempProfileForUpdate
        ? SettingsStore.tempProfileForUpdate.src
        : SettingsStore.profile
          ? SettingsStore.profile.src
          : defaultImgForLiasionAccess;
    }
  };

  return (
    <>
      {uploadImgStatus === "uploading" && (
        <div className="login_loader_container">
          <img className="loader_gif" src={loaderGIF} alt="loading..." />
        </div>
      )}
      <div className="add_image_container">
        <div className="default_image_name_wrapper">
          <p className={`message ${uploadMessage.isError ? "red_text" : ""}`}>
            {uploadMessage.message}
          </p>
          <button onClick={handleFileClick}>
            <img
              src={getCurrentProfile()}
              alt="default"
              className={`${
                SettingsStore.profile ? "" : "cursor_pointer"
              } clickable`}
            />
          </button>

          <p className="user_name">{familyOfficeTeamNameText}</p>
        </div>
        {getContentForDashedArea()}
        <div className="bottom_button_container">
          {/* <button className="cencel_btn" onClick={handleCancel}></button> */}
          {uploadImgStatus !== "success" && uploadImgStatus !== "uploading" && (
            <ArrowButton
              type="next"
              label={
                uploadMessage.message ===
                  "Family office team profile picture uploaded successfully" &&
                location.pathname.includes(editFamilyOfficeTeamRoute)
                  ? "Save"
                  : "Save"
              }
              disabled={checkDisabled()}
              onClick={handleUpload}
            />
          )}
        </div>
      </div>
    </>
  );
};

const AddLiaisonOfficerModal = () => {
  const navigate = useNavigate();

  const handleGoToAccountAccess = () => {
    navigate("/settings", { state: { from: "liaison_office_access" } });
  };
  return (
    <div className="add_liaison_officer_modal_container">
      <img
        className="add_liaison_officer_img"
        src={addLiaisonOfficer}
        alt="family office team"
      />
      <p className="add_liaison_officer_heading">
        Family office team added successfully
      </p>
      <p className="add_liaison_officer_sub_heading">
        You can enable or disable your manager’s access privilages from your
        Account Access settings
      </p>
      <div className="go_to_account_access" onClick={handleGoToAccountAccess}>
        <button>
          <div className="img_wrapper">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22 17V16.5C22 15.837 21.7366 15.2011 21.2678 14.7322C20.7989 14.2634 20.163 14 19.5 14C18.837 14 18.2011 14.2634 17.7322 14.7322C17.2634 15.2011 17 15.837 17 16.5V17C16.45 17 16 17.45 16 18V22C16 22.55 16.45 23 17 23H22C22.55 23 23 22.55 23 22V18C23 17.45 22.55 17 22 17ZM21 17H18V16.5C18 15.67 18.67 15 19.5 15C20.33 15 21 15.67 21 16.5V17ZM8 8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8ZM14 20H4V18C4 15.79 7.58 14 12 14C13.27 14 14.46 14.15 15.53 14.41C15.32 14.82 15.15 15.25 15.07 15.71C14.42 16.26 14 17.08 14 18V20Z"
                fill="white"
              />
              <path
                d="M22 17V16.5C22 15.837 21.7366 15.2011 21.2678 14.7322C20.7989 14.2634 20.163 14 19.5 14C18.837 14 18.2011 14.2634 17.7322 14.7322C17.2634 15.2011 17 15.837 17 16.5V17C16.45 17 16 17.45 16 18V22C16 22.55 16.45 23 17 23H22C22.55 23 23 22.55 23 22V18C23 17.45 22.55 17 22 17ZM21 17H18V16.5C18 15.67 18.67 15 19.5 15C20.33 15 21 15.67 21 16.5V17Z"
                fill="white"
              />
            </svg>

            {/* <img src={accountAccessIcon} alt="account access" /> */}
          </div>
        </button>

        <p className="go_to_account_access_text">Go to Account Access</p>
      </div>
    </div>
  );
};

const CommonSmallModal = ({
  heading,
  subText,
  mainImgJSX,
  rightBtnText,
  onClickRightBtn,
  onCancel,
}) => {
  return (
    <div>
      <div class="permit_modal_outer padding_btm16">
        <div class="img_holder"></div>
        {mainImgJSX}
        <h2 class="permit_heading margin15">{heading}</h2>
        <h6 class="permit_msg">{subText}</h6>
        <div class="permit_btn_div marginbtn45">
          <button class="cancel_btn" onClick={onCancel}>
            Cancel
          </button>
          <h2 class="permit_permission">
            <div class="modalSetRedBtn" onClick={onClickRightBtn}>
              <label class="per_btn_label2">{rightBtnText}</label>
              <button class="permit_red_btn">
                <svg
                  width="10"
                  height="16"
                  viewBox="0 0 10 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 -4.76837e-07L9.88 8L1.88 16Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </h2>
        </div>
      </div>
    </div>
  );
};

const AddLiaisonOfficer = observer(() => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    userName: "",
    userMobile: "",
    userEmail: "",
  });
  const [errors, setErrors] = useState({
    userNameError: false,
    userMobileError: false,
    userEmailError: false,
    checkError: false,
  });
  const [isChecked, setIsChecked] = useState(false);
  const location = useLocation();
  const [isToggleDisable] = useState({
    user21Istoggle: false,
    user22Istoggle: false,
    user23Istoggle: false,
    user24Istoggle: false,
  });
  const [isAllDis] = useState(false);
  const [addLiaisonSuccessModal, setAddLiaisonSuccessModal] = useState(false);
  const [disableAccessModal, setDisableAccessModal] = useState(false);
  const [removePhotoModal, setRemovePhotoModal] = useState(false);
  const [userType, setUserType] = useState("");
  const [userData, setUserData] = useState([]);
  const [toggleConfig, setToggleConfig] = useState();
  const [uploadPictureModal, setUploadPictureModal] = useState(false);
  const [uploadMessage, setUploadMessage] = useState({
    message: "",
    isError: false,
  });
  const [isUploadSuccess, setIsUploadSuccess] = useState(false);
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = useState(false);
  const [uploadImgStatus, setUploadImgStatus] = useState("idle");
  const [currentFamilyMembers, setCurrentFamilyMembers] = useState(
    UserStore?.currentFamilyMembers?.map((member) => {
      return {
        accessEnabled: member.app_access_enabled,
        client: {
          ...member,
        },
      };
    }),
  );

  const settingHydrated = SettingsStore.isHydrated;
  const userHydrated = UserStore.isHydrated;

  const handleCancel = () => {
    setUploadMessage({
      message: "",
      isError: false,
    });
    if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
      SettingsStore.updateProfile(null);
    }
    if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
      SettingsStore.setTempProfile(null);
    }
    setUploadPictureModal(false);
    setIsUploadSuccess(false);
  };

  const handleClose = () => {
    setUploadPictureModal(false);
    setUploadMessage({
      message: "",
      isError: false,
    });
  };

  const handleToggle = (e, data) => {
    const { name } = e.target;

    if (name !== "All") {
      setUserData([data]);
      setToggleConfig(!data.accessEnabled);
      setUserType(name);
      setDisableAccessModal(true);
    } else if (
      data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      setUserType("All");
      setUserData(data);
      setToggleConfig(isAllDis);
      setDisableAccessModal(true);
    } else if (
      data.length > 1 &&
      !data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      const liaisonOfficerData = SettingsStore?.liaisonOfficerData;
      const accountAccess = data.map((familyMember) => {
        return {
          accessEnabled: true,
          client: {
            user_id: familyMember.client.user_id,
          },
        };
      });
      const payload = { AccountAccess: accountAccess };
      if (
        liaisonOfficerData.accountAccess
          .map((eachClient) => !eachClient.AccessEnabled)
          .every(Boolean)
      ) {
        payload.AccessEnabled = true;
      } else {
        payload.AccessEnabled = liaisonOfficerData.accessEnabled;
      }
      payload.Profile = {
        full_name: liaisonOfficerData.profile.full_name,
        PhoneNo: liaisonOfficerData.profile.phoneNo,
        EmailId: liaisonOfficerData.profile.emailId,
      };
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callUpdateLaisonOfficerData(
        SettingsStore?.liaisonOfficerData.profile.id,
        payload,
      );
    }
  };

  const handleToggleForAdd = (e, data) => {
    const { name } = e.target;

    if (name !== "All") {
      setUserData([data]);
      setToggleConfig(!data.accessEnabled);
      setUserType(name);
      setDisableAccessModal(true);
    } else if (
      data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      setUserType("All");
      setUserData(data);
      setToggleConfig(isAllDis);
      setDisableAccessModal(true);
    } else if (
      data.length > 1 &&
      !data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      setCurrentFamilyMembers(
        currentFamilyMembers.map((familyMember) => {
          return { ...familyMember, accessEnabled: true };
        }),
      );
      setDisableAccessModal(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsSubmitBtnDisabled(false);
    if (
      name === "userMobile" &&
      !(value.length <= 10 && /^[0-9]*$/.test(value)) &&
      value !== ""
    ) {
      // do nothing
    } else {
      setCredentials((prevState) => {
        return { ...prevState, [name]: value };
      });

      if (name === "userName") {
        setErrors((prevState) => {
          return { ...prevState, userNameError: false };
        });
      }
      if (name === "userEmail") {
        setErrors((prevState) => {
          return { ...prevState, userEmailError: false };
        });
      }
      if (name === "userMobile") {
        setErrors((prevState) => {
          return { ...prevState, userMobileError: false };
        });
      }
    }
  };

  useEffect(() => {
    if (SettingsStore.isHydrated && UserStore.isHydrated) {
      if (location.pathname.includes(editFamilyOfficeTeamRoute)) {
        setCredentials((prevState) => {
          return {
            userName: SettingsStore.liaisonOfficerData?.profile?.full_name,
            userMobile: SettingsStore.liaisonOfficerData?.profile?.phoneNo,
            userEmail: SettingsStore.liaisonOfficerData?.profile?.emailId,
          };
        });
        setIsChecked(true);
      } else if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
        UserStore.getFamilyClients(null, () => {
          AuthStore.updateLoadingFullScreen(false);
        });
      }
    }
  }, [
    location.pathname,
    settingHydrated,
    userHydrated,
    //  SettingsStore.isHydrated, UserStore.isHydrated
  ]);

  const handleUploadPicture = () => {
    !location?.pathname?.includes(addFamilyOfficeTeamRoute) &&
      setUploadPictureModal(true);
  };

  const handleNavigate = () => {
    const liaisonOfficerData = toJS(SettingsStore?.liaisonOfficerData);
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    SettingsStore.callDeleteLaisonOfficerData(
      liaisonOfficerData?.profile?.id,
      () => {
        navigate("/settings", {
          state: { from: "liaison_office_access", deletedManager: true },
        });
        SettingsStore.updateProfile(null);
        SettingsStore.setTempProfile(null);
      },
    );
  };

  const toggle = (data) => {
    if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
      if (data.length === 1) {
        const updatedFamilyMembers = currentFamilyMembers.map(
          (familyMember) => {
            if (familyMember.client.user_id === data[0].client.user_id) {
              return {
                ...familyMember,
                accessEnabled: !data[0].accessEnabled,
              };
            } else {
              return {
                ...familyMember,
                accessEnabled: familyMember.accessEnabled,
              };
            }
          },
        );
        setDisableAccessModal(false);
        setCurrentFamilyMembers(updatedFamilyMembers);
      } else if (
        data.length > 1 &&
        data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
      ) {
        const updatedFamilyMembers = data.map((familyMember) => {
          return {
            ...familyMember,
            accessEnabled: false,
          };
        });
        setDisableAccessModal(false);
        setCurrentFamilyMembers(updatedFamilyMembers);
      }
    } else {
      const liaisonOfficerData = SettingsStore?.liaisonOfficerData;
      if (data.length === 1) {
        const accountAccess = liaisonOfficerData.accountAccess.map(
          (familyMember) => {
            if (familyMember.client.user_id === data[0].client.user_id) {
              return {
                accessEnabled: !data[0].accessEnabled,
                client: {
                  user_id: familyMember.client.user_id,
                },
              };
            } else {
              return {
                accessEnabled: familyMember.accessEnabled,
                client: {
                  user_id: familyMember.client.user_id,
                },
              };
            }
          },
        );
        const payload = { AccountAccess: accountAccess };
        if (
          liaisonOfficerData.accountAccess
            .map((eachClient) => !eachClient.AccessEnabled)
            .every(Boolean)
        ) {
          payload.AccessEnabled = true;
        } else {
          payload.AccessEnabled = liaisonOfficerData.accessEnabled;
        }
        payload.Profile = {
          full_name: liaisonOfficerData.profile.full_name,
          PhoneNo: liaisonOfficerData.profile.phoneNo,
          EmailId: liaisonOfficerData.profile.emailId,
        };
        window.scrollTo(0, 0);
        AuthStore.updateLoadingFullScreen(true);
        SettingsStore.callUpdateLaisonOfficerData(
          liaisonOfficerData.profile.id,
          payload,
        );
      } else if (
        data.length > 1 &&
        data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
      ) {
        const accountAccess = data.map((familyMember) => {
          return {
            accessEnabled: false,
            client: {
              user_id: familyMember.client.user_id,
            },
          };
        });
        const payload = { AccountAccess: accountAccess };
        payload.AccessEnabled = liaisonOfficerData.accessEnabled;
        payload.Profile = {
          full_name: liaisonOfficerData.profile.full_name,
          PhoneNo: liaisonOfficerData.profile.phoneNo,
          EmailId: liaisonOfficerData.profile.emailId,
        };
        window.scrollTo(0, 0);
        AuthStore.updateLoadingFullScreen(true);
        SettingsStore.callUpdateLaisonOfficerData(
          SettingsStore?.liaisonOfficerData.profile.id,
          payload,
        );
      }
      setDisableAccessModal(false);
    }
  };

  const handleSubmit = () => {
    const { userEmail, userMobile, userName } = credentials;

    if (
      checkUserEmailValidation(userEmail) &&
      userMobile.length === 10 &&
      checkUserNameValidation(userName) &&
      isChecked
    ) {
      if (location?.pathname?.includes(addFamilyOfficeTeamRoute)) {
        const AccountAccess = currentFamilyMembers.map((familyMember) => {
          return {
            AccessEnabled: familyMember.accessEnabled,
            client: {
              user_id: familyMember.client.user_id,
            },
          };
        });
        const Profile = {
          profile_pic: SettingsStore.addLiaisonOfficerUrl,
          full_name: credentials.userName,
          PhoneNo: credentials.userMobile,
          EmailId: credentials.userEmail,
        };
        const AccessEnabled = true;

        window.scrollTo(0, 0);
        AuthStore.updateLoadingFullScreen(true);
        const payload = { Profile, AccountAccess, AccessEnabled };
        SettingsStore.callcreateLaisonOfficersData(payload, () =>
          setAddLiaisonSuccessModal(true),
        );
      } else {
        const liaisonOfficerData = SettingsStore?.liaisonOfficerData;
        const accountAccess = liaisonOfficerData?.accountAccess?.map(
          (familyMember) => {
            return {
              accessEnabled: familyMember.accessEnabled,
              client: {
                user_id: familyMember.client.user_id,
              },
            };
          },
        );
        const payload = { AccountAccess: accountAccess };
        payload.AccessEnabled = liaisonOfficerData.accessEnabled;
        payload.Profile = {
          full_name: credentials.userName,
          PhoneNo: credentials.userMobile,
          EmailId: credentials.userEmail,
        };
        window.scrollTo(0, 0);
        AuthStore.updateLoadingFullScreen(true);
        SettingsStore.callUpdateLaisonOfficerData(
          liaisonOfficerData.profile.id,
          payload,
          () =>
            navigate("/settings", {
              state: { from: "liaison_office_access", deletedManager: false },
            }),
        );
      }
    } else {
      if (!checkUserNameValidation(userName)) {
        setErrors((prevState) => {
          return { ...prevState, userNameError: true };
        });
        setIsSubmitBtnDisabled(true);
      } else {
        setErrors((prevState) => {
          return { ...prevState, userNameError: false };
        });
      }
      if (userMobile.length < 10) {
        setErrors((prevState) => {
          return { ...prevState, userMobileError: true };
        });
        setIsSubmitBtnDisabled(true);
      } else {
        setErrors((prevState) => {
          return { ...prevState, userMobileError: false };
        });
      }
      if (!checkUserEmailValidation(userEmail)) {
        setErrors((prevState) => {
          return { ...prevState, userEmailError: true };
        });
        setIsSubmitBtnDisabled(true);
      } else {
        setErrors((prevState) => {
          return { ...prevState, userEmailError: false };
        });
      }
      if (!isChecked) {
        setErrors((prevState) => {
          return { ...prevState, checkError: true };
        });
        setIsSubmitBtnDisabled(true);
      } else {
        setErrors((prevState) => {
          return { ...prevState, checkError: false };
        });
      }
    }
  };

  const handleRemovePhoto = () => {
    ProfileStore2.deleteProfile2({
      pic_id: SettingsStore.liaisonOfficerData.profile?.profile_pic
        .split("blob/")[1]
        .split(".")[0],
      onSuccess: (data) => {
        SettingsStore.updateAddLiaisonOfficerUrl(null);
        setRemovePhotoModal(false);
        SettingsStore.updateProfile(null);
        SettingsStore.setTempProfile(null);
        SettingsStore.removeProfilePhoto();
      },
      onFail: (error) => {
        setRemovePhotoModal(false);
      },
    });
  };

  const checkUserNameValidation = (userName) => {
    return /\d/.test(userName) ||
      userName.split(" ").length > 3 ||
      userName.split(" ")[0].length < 1
      ? false
      : true;
  };

  useEffect(() => {
    if (UserStore.isHydrated) {
      setCurrentFamilyMembers(
        UserStore?.currentFamilyMembers?.map((member) => {
          return {
            accessEnabled: member.app_access_enabled,
            client: {
              ...member,
            },
          };
        }),
      );
    }
  }, [
    userHydrated,
    //  UserStore.isHydrated
  ]);

  useEffect(() => {
    const { userName, userEmail, userMobile } = credentials;
    if (isChecked && userName && userEmail && userMobile) {
      setIsSubmitBtnDisabled(false);
    }
  }, [isChecked, credentials]);

  const getAllMembersImageData = () => {
    if (location.pathname.includes(addFamilyOfficeTeamRoute)) {
      return userData.map((eachClientObj) => {
        return {
          title: eachClientObj.client.full_name,
          image:
            UserStore.currentFamilyMembersImages?.[
              eachClientObj.client.user_id
            ],
        };
      });
    } else {
      return userData.map((eachClientObj) => {
        return {
          title: eachClientObj.client.full_name,
          image:
            SettingsStore.liaisonOfficerImages?.[eachClientObj.client.user_id],
        };
      });
    }
  };

  useEffect(() => {
    if (uploadPictureModal) {
      setUploadImgStatus("idle");
    }
    return () => {
      setUploadImgStatus("idle");
    };
  }, [uploadPictureModal]);

  useEffect(() => {
    const { user_type, primary } = getDecodedToken();
    if (user_type !== "customer") navigate("/not-found");
    else if (primary !== "true") navigate("/settings");
    // eslint-disable-next-line
  }, []);

  return (
    <Observer>
      {() => (
        <>
          {AuthStore.isLoadingFullScreen ||
          AuthStore.isLoadingForSettingsLO ||
          !UserStore.isHydrated ? (
            <LoadingScreen />
          ) : (
            <>
              <Header type="settings" />
              <div className="add_liaison_officer_out">
                <div className="add_liaison_inside_main">
                  <div className="first_div">
                    <div className="head_div">
                      <PageHeading
                        headingClass="page-heading"
                        headingText={
                          location?.pathname?.includes(
                            editFamilyOfficeTeamRoute,
                          )
                            ? `Edit ${familyOfficeTeamNameText}`
                            : location?.pathname?.includes(
                                  addFamilyOfficeTeamRoute,
                                )
                              ? `Add ${familyOfficeTeamNameText}`
                              : familyOfficeTeamNameText
                        }
                      />
                      {location?.pathname?.includes(
                        editFamilyOfficeTeamRoute,
                      ) && (
                        <button
                          className="delete-button"
                          onClick={handleNavigate}
                        >
                          Delete Manager
                        </button>
                      )}
                    </div>
                    <InputForLiaison
                      isEditable={location?.pathname?.includes(
                        addFamilyOfficeTeamRoute,
                      )}
                      label={
                        location?.pathname?.includes(editFamilyOfficeTeamRoute)
                          ? "Name"
                          : "Enter Your Family Office Team’s Name"
                      }
                      value={credentials.userName}
                      onChange={(e) => handleChange(e)}
                      name={"userName"}
                      type={"not_num"}
                      error={errors.userNameError}
                      errorMsg="Please enter name"
                    />
                    <InputForLiaison
                      isEditable={location?.pathname?.includes(
                        addFamilyOfficeTeamRoute,
                      )}
                      label={
                        location?.pathname?.includes(editFamilyOfficeTeamRoute)
                          ? "Phone Number"
                          : "Enter Your Family Office Team’s Phone Number"
                      }
                      value={credentials.userMobile}
                      onChange={(e) => handleChange(e)}
                      name={"userMobile"}
                      type={"num"}
                      error={errors.userMobileError}
                      errorMsg="Please enter valid 10 digit mobile number"
                    />
                    <InputForLiaison
                      isEditable={location?.pathname?.includes(
                        addFamilyOfficeTeamRoute,
                      )}
                      label={
                        location?.pathname?.includes(editFamilyOfficeTeamRoute)
                          ? "Email ID"
                          : "Enter Your Family Office Team’s Email ID"
                      }
                      value={credentials.userEmail}
                      onChange={(e) => handleChange(e)}
                      name={"userEmail"}
                      type={"not_num"}
                      error={errors.userEmailError}
                      errorMsg="Please enter valid email address"
                    />
                    <h2 className="family_title">Account Access Permissions</h2>
                    {location.pathname.includes(addFamilyOfficeTeamRoute) ? (
                      <>
                        {" "}
                        <div
                          className="set_family_card"
                          style={{
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                            width: "inherit",
                          }}
                        >
                          <div className="family_row">
                            <p className="title1">All Members</p>{" "}
                            <ToggleButton
                              isToggleDisable={
                                !(currentFamilyMembers
                                  ? currentFamilyMembers
                                      .map(
                                        (familyMember) =>
                                          familyMember.accessEnabled,
                                      )
                                      .every(Boolean)
                                  : false)
                              }
                              handleToggle={(e, data) =>
                                handleToggleForAdd(e, data)
                              }
                              data={currentFamilyMembers}
                              name={"All"}
                            />
                          </div>
                          {currentFamilyMembers?.map((data, index) => {
                            return (
                              <div className="family_row_other">
                                {data?.client?.profile_pic &&
                                UserStore.currentFamilyMembersImages?.[
                                  data?.client?.user_id
                                ] ? (
                                  <img
                                    className="member_profile_img"
                                    height={41}
                                    width={41}
                                    src={
                                      UserStore.currentFamilyMembersImages
                                        ? UserStore.currentFamilyMembersImages[
                                            data?.client?.user_id
                                          ]
                                        : null
                                    }
                                    alt="profile"
                                  />
                                ) : (
                                  <div className="no_imagg">
                                    <p>
                                      {
                                        data?.client?.full_name?.split(
                                          " ",
                                        )[0][0]
                                      }
                                    </p>
                                  </div>
                                )}
                                <p className="title2">
                                  {data?.client?.full_name}
                                </p>
                                <ToggleButton
                                  isToggleDisable={!data?.accessEnabled}
                                  handleToggle={(e, data) =>
                                    handleToggleForAdd(e, data)
                                  }
                                  data={data}
                                  name={Object.keys(isToggleDisable)[index]}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </>
                    ) : (
                      <SettingFamilyCard
                        isAllDis={
                          SettingsStore?.liaisonOfficerData?.accountAccess
                            ? SettingsStore?.liaisonOfficerData?.accountAccess
                                .map(
                                  (familyMember) => familyMember.accessEnabled,
                                )
                                .every(Boolean)
                            : false
                        }
                        isToggleDisable={isToggleDisable}
                        family_data={
                          SettingsStore?.liaisonOfficerData?.accountAccess
                        }
                        getFamilyMemberImageFrom={
                          SettingsStore.liaisonOfficerImages
                        }
                        handleToggle={(e, data) => handleToggle(e, data)}
                        borderObje={{
                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                          borderBottomLeftRadius: "10px",
                          borderBottomRightRadius: "10px",
                          width: "inherit",
                        }}
                      />
                    )}
                    <div className="accept_term_div_with_error">
                      <div
                        className={"accept_term_div"}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsChecked((prevState) => !prevState);
                          if (!isChecked) {
                            setErrors((prevState) => {
                              return {
                                ...prevState,
                                checkError: false,
                              };
                            });
                          } else {
                            setIsSubmitBtnDisabled(false);
                          }
                        }}
                      >
                        <input
                          className="addliaison_input_checkbox"
                          type="checkbox"
                          checked={isChecked}
                          style={{ cursor: "pointer" }}
                        />{" "}
                        <h3>
                          By giving access, you agree to your Family Office Team
                          having access to view all holdings for the members you
                          select.{" "}
                        </h3>
                      </div>
                      {errors.checkError && (
                        <span className="add_liaison_input_error_msg">
                          Please accept the terms for adding Family Office Team
                          details
                        </span>
                      )}
                    </div>
                    <div className="add_btn_div">
                      <p
                        className="cancelbtn"
                        onClick={() =>
                          navigate("/settings", {
                            state: {
                              from: "liaison_office_access",
                              fromPath: location?.pathname?.includes(
                                addFamilyOfficeTeamRoute,
                              ),
                            },
                          })
                        }
                      >
                        Cancel
                      </p>
                      <SettingModalButton
                        disabled={isSubmitBtnDisabled}
                        label={"Submit"}
                        toggle={handleSubmit}
                      />
                    </div>
                  </div>
                  <div className="sec_div">
                    {(location?.pathname?.includes(addFamilyOfficeTeamRoute) &&
                      !SettingsStore.profile) ||
                    (location?.pathname?.includes(editFamilyOfficeTeamRoute) &&
                      !SettingsStore.profile) ? (
                      <>
                        <p className="upload_picture_text">Upload Picture</p>
                        <div className="upload_picture_btn_wrapper">
                          <button onClick={handleUploadPicture}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="27"
                              height="23"
                              viewBox="0 0 27 23"
                              fill="none"
                            >
                              <path
                                d="M10.1011 0.333984L8.28668 3.96287H3.93202C2.12265 3.96287 0.666016 5.41951 0.666016 7.22887V18.8413C0.666016 20.6507 2.12265 22.1073 3.93202 22.1073H23.528C25.3374 22.1073 26.794 20.6507 26.794 18.8413V7.22887C26.794 5.41951 25.3374 3.96287 23.528 3.96287H19.1733L17.3589 0.333984H10.1011ZM13.73 7.95465C16.5359 7.95465 18.8105 10.2292 18.8105 13.0351C18.8105 15.841 16.5359 18.1155 13.73 18.1155C10.9242 18.1155 8.64957 15.841 8.64957 13.0351C8.64957 10.2292 10.9242 7.95465 13.73 7.95465Z"
                                fill="white"
                              />
                            </svg>
                            {/* <img src={uploadPicture} alt="upload" /> */}
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="uploaded_img">
                          <img
                            className="up_img"
                            src={SettingsStore.profile?.src}
                            alt="officer"
                          />
                          <div className="camera_btn_container">
                            <button className="camera">
                              <img src={uploadPicture} alt="camera" />
                            </button>
                            <div className="tooltip2">
                              <ul className="camera_tooltip_listitems">
                                <li
                                  className="camera_tooltip_listitem"
                                  onClick={() => setUploadPictureModal(true)}
                                >
                                  <div className="change_image_wrapper">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M6.14147 0.512594C6.44171 0.512594 6.72105 0.667356 6.88007 0.922326L7.46855 1.8656H8.38513C8.71862 1.8656 9.03846 1.99808 9.27427 2.2339C9.51009 2.46971 9.64257 2.78955 9.64257 3.12304V7.95935C9.64257 8.29284 9.51009 8.61268 9.27427 8.84849C9.03846 9.08431 8.71862 9.21679 8.38513 9.21679H1.6143C1.2808 9.21679 0.960969 9.08431 0.725153 8.84849C0.489337 8.61268 0.356857 8.29284 0.356857 7.95935V3.12304C0.356857 2.78955 0.489337 2.46971 0.725153 2.2339C0.960969 1.99808 1.2808 1.8656 1.6143 1.8656H2.60826L3.14257 0.94554C3.2191 0.813764 3.32889 0.704386 3.46095 0.628342C3.593 0.552298 3.74271 0.512252 3.8951 0.512207H6.14108L6.14147 0.512594ZM4.99971 3.22093C4.43534 3.22093 3.89408 3.44512 3.49501 3.8442C3.09593 4.24327 2.87174 4.78453 2.87174 5.3489C2.87174 5.91328 3.09593 6.45454 3.49501 6.85361C3.89408 7.25268 4.43534 7.47688 4.99971 7.47688C5.56409 7.47688 6.10535 7.25268 6.50442 6.85361C6.90349 6.45454 7.12769 5.91328 7.12769 5.3489C7.12769 4.78453 6.90349 4.24327 6.50442 3.8442C6.10535 3.44512 5.56409 3.22093 4.99971 3.22093ZM4.99971 3.80128C5.41017 3.80128 5.80381 3.96434 6.09404 4.25457C6.38428 4.54481 6.54733 4.93845 6.54733 5.3489C6.54733 5.75936 6.38428 6.153 6.09404 6.44324C5.80381 6.73347 5.41017 6.89652 4.99971 6.89652C4.58926 6.89652 4.19562 6.73347 3.90538 6.44324C3.61515 6.153 3.45209 5.75936 3.45209 5.3489C3.45209 4.93845 3.61515 4.54481 3.90538 4.25457C4.19562 3.96434 4.58926 3.80128 4.99971 3.80128Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M4.99942 3.80127C5.40987 3.80127 5.80351 3.96432 6.09375 4.25456C6.38398 4.54479 6.54703 4.93843 6.54703 5.34889C6.54703 5.75934 6.38398 6.15299 6.09375 6.44322C5.80351 6.73345 5.40987 6.89651 4.99942 6.89651C4.58896 6.89651 4.19532 6.73345 3.90508 6.44322C3.61485 6.15299 3.4518 5.75934 3.4518 5.34889C3.4518 4.93843 3.61485 4.54479 3.90508 4.25456C4.19532 3.96432 4.58896 3.80127 4.99942 3.80127Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </div>
                                  <span className="change_image_text">
                                    {" "}
                                    Change Image
                                  </span>
                                </li>
                                <li
                                  className="camera_tooltip_listitem"
                                  onClick={() => setRemovePhotoModal(true)}
                                >
                                  <div className="remove_photo_wrapper">
                                    {/* <img src={closeIconWhite} alt="remove" /> */}
                                    <svg
                                      width="12"
                                      height="12"
                                      viewBox="0 0 12 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.41667 3.25293L3 8.6696"
                                        stroke="white"
                                        stroke-width="1.625"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M3 3.25293L8.41667 8.6696"
                                        stroke="white"
                                        stroke-width="1.625"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                  <span className="remove_photo_text">
                                    Remove Photo
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <Modal
                onClose={handleClose}
                showCloseIcon={
                  uploadImgStatus !== "success" &&
                  uploadImgStatus !== "uploading"
                    ? true
                    : false
                }
                open={uploadPictureModal}
                title={
                  location.pathname.includes(editFamilyOfficeTeamRoute) &&
                  !uploadMessage.isError &&
                  SettingsStore.profile
                    ? "Update Picture"
                    : "Upload Picture"
                }
                width={"800px"}
              >
                <AddImageModalContent
                  uploadMessage={uploadMessage}
                  setUploadMessage={setUploadMessage}
                  handleCancel={handleCancel}
                  isUploadSuccess={isUploadSuccess}
                  setIsUploadSuccess={setIsUploadSuccess}
                  setUploadImgStatus={setUploadImgStatus}
                  uploadImgStatus={uploadImgStatus}
                  location={location}
                  setUploadPictureModal={setUploadPictureModal}
                />
              </Modal>
              <Modal
                onClose={() => {
                  setAddLiaisonSuccessModal(false);
                  navigate("/settings", {
                    state: { from: "liaison_office_access" },
                  });
                }}
                open={addLiaisonSuccessModal}
                title={`Add ${familyOfficeTeamNameText}`}
                width="754px"
                minWidth="754px"
                modalContainerClass="add_liaison_officer_modal"
              >
                <AddLiaisonOfficerModal />
              </Modal>
              <Modal
                onClose={() => setDisableAccessModal(false)}
                open={disableAccessModal}
                width="453px"
                minWidth="453px"
                modalContainerClass="disable_liasion_access_modal"
              >
                <SettingPermitModal
                  userType1={userType}
                  data={userData}
                  getFamilyMemberImageFrom={
                    location.pathname.includes(addFamilyOfficeTeamRoute)
                      ? UserStore.currentFamilyMembersImages
                      : SettingsStore.liaisonOfficerImages
                  }
                  isToggleDisable={toggleConfig}
                  type={"access"}
                  onClose={() => setDisableAccessModal(false)}
                  allMembersImagedata={getAllMembersImageData()}
                  userType={`your ${familyOfficeTeamNameText} Access`}
                  image={""}
                  toggle={(data) => toggle(data)}
                />
              </Modal>
              <Modal
                onClose={() => setRemovePhotoModal(false)}
                open={removePhotoModal}
                width="438px"
                minWidth="438px"
                modalContainerClass="disable_liasion_access_modal"
              >
                <CommonSmallModal
                  heading="Remove Photo?"
                  subText="You can add image again by clicking on the change image button in Family office team profile"
                  mainImgJSX={
                    <div className="image_bg">
                      <img src={cameraIcon} alt="user" />
                    </div>
                  }
                  rightBtnText="Yes, Remove"
                  onClickRightBtn={handleRemovePhoto}
                  onCancel={() => setRemovePhotoModal(false)}
                />
              </Modal>
            </>
          )}
        </>
      )}
    </Observer>
  );
});

export default AddLiaisonOfficer;
